import React, { useState, useEffect } from 'react';

function CreateExamModal({ isOpen, onClose, onSubmit, treeList }) {
  const [formData, setFormData] = useState({
    tree_id: '',
    total_problems: 1,
    difficulty: 1
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      ...formData,
      tree_id: parseInt(formData.tree_id),
      difficulty: formData.difficulty - 1
    });
  };

  return (
    isOpen && (
      <div 
        className="fixed inset-0 flex items-center justify-center"
        style={{
          zIndex: 9999980,
          paddingTop: window.innerWidth < 768 ? 'env(safe-area-inset-top, 0px)' : '0px',
          paddingBottom: window.innerWidth < 768 ? 'calc(68px + env(safe-area-inset-bottom, 0px))' : '0px',
          backgroundColor: 'rgba(0, 0, 0, 0.3)'
        }}
      >
        <div className="w-96 rounded-3xl bg-white p-6">
          <h2 className="mb-4 text-xl font-bold">시험지 생성</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="mb-2 block">교육과정</label>
              <select 
                className="w-full rounded border p-2"
                value={formData.tree_id}
                onChange={(e) => setFormData({
                  ...formData, 
                  tree_id: parseInt(e.target.value) || ''
                })}
                required
              >
                <option value="">선택하세요</option>
                {treeList
                  .filter(tree => tree.is_closed)
                  .map((tree) => (
                    <option key={tree.tree_id} value={tree.tree_id}>
                      {tree.tree_name} ({tree.edu_ver})
                    </option>
                ))}
              </select>
            </div>
            <div className="mb-4">
              <label className="mb-2 block">문제 수 (1-100)</label>
              <input
                type="number"
                min="1"
                max="100"
                className="w-full rounded border p-2"
                value={formData.total_problems}
                onChange={(e) => setFormData({...formData, total_problems: parseInt(e.target.value)})}
                required
              />
            </div>
            <div className="mb-4">
              <label className="mb-2 block">난이도 (1.0-5.0)</label>
              <input
                type="number"
                step="0.1"
                min="1"
                max="5"
                className="w-full rounded border p-2"
                value={formData.difficulty}
                onChange={(e) => setFormData({...formData, difficulty: parseFloat(e.target.value)})}
                required
              />
            </div>
            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={onClose}
                className="rounded bg-gray-200 px-4 py-2"
              >
                취소
              </button>
              <button
                type="submit"
                className="rounded bg-indigo-500 px-4 py-2 text-white"
              >
                생성
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  );
}

export default CreateExamModal; 